import { authApi as api } from './auth';

// Auth
export const changePassword    = (data)       => api.post('/auth/change-password', data);

// Dashboard
export const getDashboard      = ()           => api.get('/dashboard');

// Leads
export const getLeads          = (p={})       => api.get('/leads', { params: p });
export const getLeadsCount     = (p={})       => api.get('/leads/count', { params: p });
export const getLeadAddedByList= ()           => api.get('/leads/added-by-list');
export const getLead           = (id)         => api.get(`/leads/${id}`);
export const createLead        = (data)       => api.post('/leads', data);
export const contactsToLeads   = (contact_ids, sector) => api.post('/leads/from-contacts', { contact_ids, sector });
export const updateLead        = (id, data)   => api.patch(`/leads/${id}`, data);
export const deleteLead        = (id)         => api.delete(`/leads/${id}`);
export const generateLeads     = (data)       => api.post('/leads/generate', data);
export const importLeads       = (data)       => api.post('/leads/import', data);
export const importLeadsFile   = (file)       => { const fd=new FormData(); fd.append('file', file);
                                                    return api.post('/leads/import-file', fd); };
export const sendEmail         = (lead_id)    => api.post('/email/send', { lead_id });
export const sendFollowup      = (lead_id)    => api.post('/email/send-followup', { lead_id });
export const sendBulk          = (lead_ids)   => api.post('/email/send-bulk', { lead_ids });

// Replies
export const getReplies        = ()           => api.get('/replies');
export const getUnreadCount    = ()           => api.get('/replies/unread-count');
export const markRead          = (id)         => api.patch(`/replies/${id}/read`);
export const draftReply        = (reply_id)   => api.post('/replies/draft', { reply_id });
export const sendReply         = (data)       => api.post('/replies/send', data);
export const detectTimeline    = (reply_id)   => api.post(`/replies/${reply_id}/detect-timeline`);
export const scheduleFollowup  = (reply_id, date) => api.post(`/replies/${reply_id}/schedule-followup`, { date });
export const getSettings       = ()           => api.get('/settings');
export const correctText       = (text)       => api.post('/emails/correct-text', { text });

// Campaigns
export const getCampaigns      = ()           => api.get('/campaigns');
export const createCampaign    = (data)       => api.post('/campaigns', data);
export const pauseCampaign     = (id)         => api.patch(`/campaigns/${id}/pause`);
export const deleteCampaign    = (id)         => api.delete(`/campaigns/${id}`);

// Analytics
export const getAnalytics      = ()           => api.get('/analytics');

// Contacts
export const getContacts       = (p={})       => api.get('/contacts', { params: p });
export const getContactsCount  = (p={})       => api.get('/contacts/count', { params: p });
export const getContactAddedByList = ()       => api.get('/contacts/added-by-list');
export const getContact        = (id)         => api.get(`/contacts/${id}`);
export const createContact     = (data)       => api.post('/contacts', data);
export const importContactsFile= (file)       => { const fd=new FormData(); fd.append('file', file);
                                                    return api.post('/contacts/import-file', fd); };
export const updateContact     = (id, data)   => api.patch(`/contacts/${id}`, data);
export const deleteContact     = (id)         => api.delete(`/contacts/${id}`);
export const starContact       = (id)         => api.post(`/contacts/${id}/star`);
export const addLeadToContact  = (leadId)     => api.post(`/contacts/from-lead/${leadId}`);
export const bulkLeadsToContacts=(ids)        => api.post('/contacts/bulk-from-leads', { lead_ids: ids });

// Email manager
export const getEmails         = (p={})       => api.get('/emails', { params: p });
export const getEmailCounts    = ()           => api.get('/emails/counts');
export const composeEmail      = (data)       => api.post('/emails/compose', data);
export const fetchInbox        = ()           => api.post('/emails/fetch-inbox');
export const markEmailRead     = (id)         => api.patch(`/emails/${id}/read`);
export const toggleEmailStar   = (id)         => api.patch(`/emails/${id}/star`);
export const deleteEmail       = (id)         => api.delete(`/emails/${id}`);
export const replyToEmail      = (id, data)   => api.post(`/emails/${id}/reply`, data);
export const aiDraft           = (data)       => api.post('/emails/ai-compose', data);

// Email attachments
export const uploadAttachment  = (file)       => { const fd=new FormData(); fd.append('file', file);
                                                    return api.post('/emails/attachments', fd); };
export const deleteAttachment  = (id)         => api.delete(`/emails/attachments/${id}`);
export const downloadAttachment= async (id, filename) => {
  const r = await api.get(`/emails/attachments/${id}/download`, { responseType: 'blob' });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement('a');
  a.href = url; a.download = filename || 'attachment';
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Pipeline
export const getPipeline         = ()           => api.get('/pipeline');
export const updatePipelineStage = (id, stage)  => api.patch(`/pipeline/leads/${id}/stage`, { stage });
export const addLeadToPipeline   = (id, stage)  => api.post(`/pipeline/leads/${id}/add`, { stage });

// AI Draft review queue
export const getDrafts         = (p={})       => api.get('/drafts', { params: p });
export const getDraftCounts    = ()           => api.get('/drafts/counts');
export const generateDrafts    = (contact_ids)=> api.post('/drafts/generate', { contact_ids });
export const autoGenerateDrafts= (limit=20)   => api.post('/drafts/auto-generate', { limit });
export const updateDraft       = (id, data)   => api.patch(`/drafts/${id}`, data);
export const approveDraft      = (id)         => api.post(`/drafts/${id}/approve`);
export const rejectDraft       = (id)         => api.post(`/drafts/${id}/reject`);
export const restoreDraft      = (id)         => api.post(`/drafts/${id}/restore`);
export const deleteDraft       = (id)         => api.delete(`/drafts/${id}`);
export const deleteDraftsBulk  = (status)     => api.delete('/drafts', { params: { status } });

export default api;
